<ng-container *ngIf="{
    isConnected: isConnected$ | async,
    isAzzurroHub: isAzzurroHub$ | async,
    hasSolarimeter: hasSolarimeter$ | async,
    systemMetadata: systemMetadata$ | async,
    requestSystemPowerState: requestSystemPowerState$ | async,
    systemPowerState: systemPowerState$ | async,
  } as resolved">
  <lib-block-title
    *ngIf="labels.title"
    id="block-title"
    [title]="labels.title">
  </lib-block-title>

  <section
    *ngIf="showIrradianceInfo && resolved.isAzzurroHub && resolved.hasSolarimeter"
    id="irradiance-info"
    class="fx-col fx-gap-2 py-3">
    <div class="fx-row radius-4 block-bg-contrast fx-align-center fx-gap-3 fx-justify-between p-3">
      <ion-icon
        class="s-6 text-grey-400"
        src="cmp-assets/irradiance.svg">
      </ion-icon>
      <div class="tw-text-sm tw-font-medium text-grey-300">
        {{ labels.irradiance }}
      </div>
      <div class="tw-text-base tw-font-normal text-grey-400 ml-auto">
        <ng-container *ngIf="resolved.systemPowerState?.solarimeter?.irradiance != null; else noIrradiance">
          {{ resolved.systemPowerState?.solarimeter?.irradiance | number: '1.0-0' }} W/m²
        </ng-container>
        <ng-template #noIrradiance>--</ng-template>
      </div>
    </div>
    <div class="fx-row radius-4 block-bg-contrast fx-align-center fx-gap-3 fx-justify-between p-3">
      <ion-icon
        class="s-6 text-grey-400"
        src="cmp-assets/temperature.svg">
      </ion-icon>
      <div class="tw-text-sm tw-font-medium text-grey-300">
        {{ labels.panelTemp }}
      </div>
      <div class="tw-text-base tw-font-normal text-grey-400 ml-auto">
        <ng-container *ngIf="resolved.systemPowerState?.solarimeter?.panelTemperature != null; else noPanelTemp">
          {{ resolved.systemPowerState?.solarimeter?.panelTemperature | number: '1.0-1' }} °C
        </ng-container>
        <ng-template #noPanelTemp>--</ng-template>
      </div>
    </div>
  </section>

  <ngx-power-state
    id="power-state"
    class="mx-auto w-fit"
    [disconnected]="resolved.isConnected === false"
    [showSeconds]="(isRTActive$ | async) === true"
    [mode]="flowGraphMode$ | async"
    [duration]="duration"
    [fromSolarToGrid]="scalePower(resolved.systemPowerState?.fromSolarToGrid)"
    [fromSolarToHome]="scalePower(resolved.systemPowerState?.fromSolarToHome)"
    [fromGridToHome]="scalePower(resolved.systemPowerState?.fromGridToHome)"
    [fromGridToBattery]="scalePower(resolved.systemPowerState?.fromGridToBattery || -(resolved.systemPowerState?.fromBatteryToGrid || 0))"
    [fromSolarToBattery]="scalePower(resolved.systemPowerState?.fromSolarToBattery)"
    [fromBatteryToHome]="scalePower(resolved.systemPowerState?.fromBatteryToHome)"
    [solar]="scalePower(resolved.systemPowerState?.solar)"
    [grid]="scalePower(resolved.systemPowerState?.grid)"
    [home]="scalePower(resolved.systemPowerState?.home)"
    [batteryPower]="scalePower(resolved.systemPowerState?.batteryPower)"
    [batteryPercentage]="resolved.systemPowerState?.battery"
    [lastUpdated]="showLastUpdated ? (lastUpdate$ | async) : undefined"
    [unitSymbol]="powerUnitSymbol"
    [valuePrecision]="powerPrecision"
    [labels]="{
      home: labels.home,
      grid: labels.grid,
      solar: labels.solar,
      battery: labels.battery,
      disconnected: labels.disconnected,
      unit: labels.unit,
    }"
    [offset]="showLastUpdated ? (tz$ | async) : undefined">
  </ngx-power-state>
  <ng-container *ngIf="showWeather">
    <lib-weather-card
      class="fx-row mt-auto"
      id="weather-card"
      [weatherInfo]="weatherInfo$ | async">
    </lib-weather-card>
  </ng-container>
</ng-container>
